module.exports = __webpack_public_path__ + "img/model_45_zh.bc2748da.jpg";